import React, { memo, useCallback } from 'react';
import { Chip } from '@landr/maestro';
import { FiltersParams } from 'types/params';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';

type ActiveFilterProps = {
    filter: string;
    queryKey?: FiltersParams;
    onClick: () => void;
};

const ActiveFilter = memo(
    ({ filter, queryKey, onClick }: ActiveFilterProps) => {
        const { getFilterLabel } = useApiFiltersContext();

        const handleOnClick = useCallback(() => onClick(), [onClick]);

        const label = queryKey ? getFilterLabel(filter, queryKey) : filter;

        return (
            <Chip
                onClick={handleOnClick}
                onDismiss={handleOnClick}
                shape="rounded"
                size="sm"
                palette="secondary"
                marginTop="4px"
                marginBottom="4px"
            >
                {label}
            </Chip>
        );
    },
);

export default ActiveFilter;
